var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-loader",style:(_vm.paddingStyle)},[_c('div',{staticClass:"progress-bar ai-background",style:(_vm.progressStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }